import { CollectionConfig } from './collectionConfig';
import { parseFqdn } from '../util/parseFqdn';
import {
  WixPatternsContainer,
  WixPatternsContainerParams,
  CollectionState,
  PaginationModeRef,
} from '../state';
import { QueryCache } from 'react-query/core';
import { FiltersMap, OptionalFiltersMap } from '../model';

export interface CreateCollectionOptions {
  paginationModeRef?: PaginationModeRef;
  overrides?: Partial<WixPatternsContainerParams>;
}

export function createCollection<T, F extends FiltersMap = OptionalFiltersMap>(
  container: WixPatternsContainer,
  config: CollectionConfig<T, F>,
  { paginationModeRef, overrides }: CreateCollectionOptions = {},
) {
  const {
    errorMonitor,
    errorHandler,
    onlineState,
    history,
    translate,
    queryCache,
    showToast,
    initialFetch,
    lodash,
  } = container;

  const { queryName, fqdn } = config;

  // fallbacks to queryName for backwards compatibility
  const parsedFqdn = parseFqdn(fqdn || queryName);

  return new CollectionState({
    ...config,
    queryName,
    fqdn: parsedFqdn,
    paginationModeRef,
    queryCache:
      overrides?.queryCache ??
      (typeof process !== 'undefined' && process.env.STORYBOOK_DOCS === 'true'
        ? new QueryCache()
        : queryCache),
    history,
    errorMonitor,
    errorHandler,
    showToast: overrides?.showToast ?? showToast,
    translate,
    onlineState,
    initDependencies: initialFetch,
    lodash,
  });
}
